import {
  ComponentPropsWithoutRef,
  ElementRef,
  ForwardedRef,
  forwardRef,
} from "react"

import { css, cx } from "@emotion/css"

const styles = {
  root: css`
    border: 0;
    padding: 0;
    font-size: inherit;
    background-color: transparent;
    -webkit-appearance: none;
    color: inherit;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;

    &:focus {
      outline: 0;
    }

    ::placeholder {
      color: var(--grey, gray);
    }
  `,
}

type OurInputProps = {}

export type InputProps = ComponentPropsWithoutRef<"input"> & OurInputProps

const Input = forwardRef(function (
  props: InputProps,
  ref: ForwardedRef<ElementRef<"input">>,
) {
  const { className, ...rest } = props
  const cn = cx("Input", styles.root, className)
  return <input ref={ref} className={cn} autoComplete="off" {...rest} />
})

export default Input
